import { env as env2 } from "@rsmus/react-env-image";

/*
    The following are values found in either the .env files or in the environment variables on the machine.
    Environment variables from the machine are preferred, but .env files can be useful in development.  In such
    cases, use .env.development, since that will not propagate to the production environment.
*/

// This is a temporary work around to allow tests to succeed.  The current env function will throw
//  errors if the window object doesn't have a config property.  The offending NPM package should be
//  updated soon, and this if-block can be removed at that time.
let env = env2;
if ((window as any) != null && (window as any).config == null) {
  env = function () {
    return undefined;
  };
}

export const REACT_APP_BASE_API_URL = env("REACT_APP_BASE_API_URL");
export const REACT_APP_UPGRADE_SITE_API_URL = env("REACT_APP_UPGRADE_SITE_API_URL");
export const IsUpgradeSiteMicroserviceEnabled = env("REACT_APP_SITEUPGRADE_MICROSERVICE_ENABLED");
export const REACT_APP_BULK_SITE_CREATION_API_URL = env("REACT_APP_BULK_SITE_CREATION_API_URL");
export const REACT_APP_ROLLOVER_API_URL = env("REACT_APP_ROLLOVER_API_URL");
export const IsRolloverMicroserviceEnabled = env("REACT_APP_ROLLOVER_MICROSERVICE_ENABLED");
export const REACT_APP_USER_ASSIGNMENT_API_URL = env("REACT_APP_USER_ASSIGNMENT_API_URL");
export const REACT_APP_CUSTOM_PERMISSION_API_URL = env("REACT_APP_CUSTOM_PERMISSION_API_URL");
export const REACT_APP_IManage_FileCount_Limit = env("REACT_APP_IManage_FileCount_Limit");
export const REACT_APP_SYSTEM_ADMIN_USERS = env("REACT_APP_SYSTEM_ADMIN_USERS");
export const REACT_APP_TIMBASE_URL = env("REACT_APP_TIMBASE_URL");
export const REACT_APP_USE_FOLDER_PERMISSIONS_PAGE = env("REACT_APP_USE_FOLDER_PERMISSIONS_PAGE");
export const REACT_APP_FILE_MANAGEMENT_API_URL = env("REACT_APP_FILE_MANAGEMENT_API_URL");
export const IsFileManagementMicroserviceEnabled = env("REACT_APP_FILE_MANAGEMENT_MICROSERVICE_ENABLED");
export const REACT_APP_CORPORATE_SIGHT_API_URL = env("REACT_APP_CORPORATE_SIGHT_API_URL");
export const IsFileManagementMicroserviceEnabledUiPost = env("REACT_APP_FILE_MANAGEMENT_MICROSERVICE_ENABLED_UI_post");
export const IsFileManagementMicroserviceEnabledUiGet = env("REACT_APP_FILE_MANAGEMENT_MICROSERVICE_ENABLED_UI_GET");